import { CLIENTS } from "@/data/site";

const ClientChip = ({ client }) => (
  <div className="flex items-center shrink-0 mx-6">
    {client.logo ? (
      <span className="bg-white border border-zinc-200 rounded-full px-6 py-3 inline-flex items-center shadow-sm">
        <img
          src={client.logo}
          alt={`${client.name} logo`}
          className="h-8 w-auto object-contain"
          loading="lazy"
        />
      </span>
    ) : (
      <span className="font-display font-bold uppercase tracking-wide text-zinc-400 text-xl whitespace-nowrap px-2">
        {client.name}
      </span>
    )}
  </div>
);

const ClientMarquee = () => {
  const doubled = [...CLIENTS, ...CLIENTS];
  return (
    <section
      data-testid="clients-logo-marquee"
      className="border-y border-zinc-200 bg-white py-10 overflow-hidden"
      aria-label="Clients we've worked with"
    >
      <p className="font-mono-accent text-[10px] uppercase tracking-[0.35em] text-zinc-500 text-center mb-8 px-4">
        Clients we've worked with
      </p>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
        <div className="flex w-max animate-marquee items-center">
          {doubled.map((client, i) => (
            <ClientChip key={`${client.name}-${i}`} client={client} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientMarquee;
